<ng-container>
	<div class="mobile-filters" *ngIf="viewport.type !== 'desktop'">
		<mat-accordion>
			<mat-expansion-panel [expanded]="step === 0">
				<mat-expansion-panel-header class="n24">
					<mat-panel-title class="filter-mobile">
						<mat-icon>search</mat-icon>
						&nbsp;
						<span>{{ locale.translations['ads']['filter']['n24'] }}</span>
					</mat-panel-title>
				</mat-expansion-panel-header>
				<app-filters-desktop [sortBy]="sortBy" [isFilterReset]="isFilterReset"></app-filters-desktop>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
	<div class="desktop-filters" *ngIf="viewport.type === 'desktop'">
		<app-filters-desktop [sortBy]="sortBy" [isFilterReset]="isFilterReset"></app-filters-desktop>
	</div>
</ng-container>
